export default __webpack_public_path__ + "static/media/hospital-img-1.12943b2a.png";